<template>
  <div class="add-user" style="margin-top:25px">
    <item-management-table
        :items="items"
        :status="status"
        :fields="fields"
        @add-item-click="handleAddItemClick"
        @status-click="handleStatusClick"
        @search-input="handleSearchInput"
        @update-status-click="handleStatusClick"
        @update-fave-click="handleEditClick"
    />
    <add-item
        item-type="Crew"
        :modal-id="modalAddItemId"
        @update-items="handleUpdateCrew"
    />
  </div>
</template>

<script>
import ItemManagementTable from "./itemManagementTable";
import AddItem from "./addItem";

export default {
  name: "Admin_Manage_Crew",
  components: {
    AddItem,
    ItemManagementTable
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {
        return {};
      }
    },
    itemId: {
      type: String,
      default: "add-edit-item-status"
    }
  },
  computed: {
    items(){
      return this.provider && this.provider.crew ? this.provider.crew : [];
    }
  },
  created() {},
  mounted() {},
  methods: {
    getCrew(){

    },
    handleAddItemClick() {
      this.$bvModal.show(this.modalAddItemId);
    },
    handleStatusClick(){

    },
    handleSearchInput(){

    },
    handleEditClick(){

    },
    handleUpdateCrew(crewMembers) {
      debugger; //@ToDo- Mixin
      let createdBy = this.profileBy();

      let invites = [];
      let emails = [];

      //Set them all fam status to pending
      if(Array.isArray(crewMembers)){
        crewMembers.forEach( anIvitee =>{
          anIvitee.fid = this.inviteCode();
          anIvitee.status = {
            _created_at: Date.now(),
            _created_by: createdBy,
            inviteCode: this.inviteCode(),
            status: 'pending',
          };


          //**** INVITEES
          let customInvite = this.generateCustomInvite(anIvitee);
          if (customInvite) invites.push(customInvite);

          debugger;

          let customEmail = this.generateCustomEmailInvite(anIvitee);
          if (customEmail) emails.push(customEmail);

        });
      }

      const payload = {
        createdBy: createdBy,
        providerId: this.provider.id,
        crewMembers: crewMembers,
        invites: invites
      };

      debugger;
      if (Array.isArray(crewMembers) && crewMembers.length > 0) {
        this.$store.dispatch("admin/updateProviderCrew", payload)
            .then(res => {
              //this.getFamily();
              this.$store.dispatch("user/sendEmail", {emails:emails}).then((res)=>{
                this.$store.dispatch("user/showNotification", {
                  title: "Your crew has been updated",
                  description: "We have sent Invites to your crew.",
                  variant: "success"
                });
              });
              this.$bvModal.hide(this.modalAddItemId);
            });
      }
    },
    handleLogoUploadedURL(idx, url) {
      debugger;
      this.imgURL = url;
    },
    input(val) {
      this.description = val.content;
    },
    resetClear() {
      this.clear = false;
    },
    inviteCode(){
      let profileCode  = this.profile.userId.substr(3, 4);
      let timeStamp = Date.now().valueOf();
      let rndCode = this.generateRnd(5);
      return `${profileCode}${timeStamp}_${rndCode}`;
    },
    generateRnd(charactersLength){
      let result = "";
      var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      // var charactersLength = characters.length;
      for (var i = 0; i < 15; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    generateCustomEmailInvite(invitee){
      if(invitee.user && invitee.user.email) {
        let inviterName =`${this.profile.firstname}`;  //this user for now
        let providerName =`${this.provider && this.provider.info && this.provider.info.name ? this.provider.info.name : "HBF"}`;  //this user for now
        let subject =`${inviterName} invited you join ${providerName}`;
        let fromEmail='providers@heartbeatfam.com';
        let toEMail = invitee.user.email;
        let recipientName = invitee.nickname ? invitee.nickname : '';
        let supportEmail='care@heartbeatfam.com';
        let inviteCode= invitee.status.inviteCode;

        let emailText = `Hi, ${recipientName}, ${inviterName} has invited you to join the provider account of ${providerName}.`;
        emailText+=`Join here https://heartbeatfam.com/invite/provider/${inviteCode}`;
        emailText+=` \nOur support email is ${supportEmail}`;

        let theEmail = {
          "subject": subject,
          "from": {
            "email": `${fromEmail}`
          },
          "to": [
            {
              "email": `${toEMail}`
            }
          ],
          "text": emailText
        };
        return theEmail;
      }
      return null;
    },
    generateCustomInvite(invitee) {
      return {
        reqUID: this.profile && this.profile.userId ? this.profile.userId : null,
        provider: {
          id:  this.provider && this.provider.id ? this.provider.id  : null,
          name:  this.provider && this.provider.info && this.provider.info.name ? this.provider.info.name  : null,
          profileName:  this.provider && this.provider.info && this.provider.info.profileName ? this.provider.info.profileName  : null,
          imgURL:  this.provider && this.provider.info && this.provider.info.imgURL ? this.provider.info.imgURL  : null,
        },
        inviter: {
          name: this.profile.firstname, //@ToDo - make firstname later- verify locations
          firstname: this.profile.firstname,
          lastname: this.profile.lastname,
          imgURL: this.profile.imgURL
        },
        rec:{
          nickname:  invitee.nickname ? invitee.nickname : null,
          relation:  invitee.relation ? invitee.relation :null ,
          uid: invitee.user && invitee.user.userId ? invitee.user.userId : null,
          email: invitee.user && invitee.user.email ? invitee.user.email : null,
        },
        inviteCode:invitee.status.inviteCode,
        _created_at:new Date(),
        _expire_at: new Date(Date.now() + ( 3600 * 1000 * 24 * 15)),
        status: `pending`
      }
    },
    profileBy() {
      return {
        uid: this.profile.userId,
        name: `${this.profile.firstname} ${this.profile.lastname}`,
        imgURL: this.profile.imgURL
      };
    }
  },
  data() {
    return {
      status: null, //|all | submitted | needs_work | inactive
      roleOptions: [],
      clear: false,
      idx: 0,
      storagePath: "providers_logos_imgs",
      isUpdate: false,
      name: null,
      description: [],
      brand: null,
      url: null,
      comment: null,
      imgURL: null,
      providerData: null,
      modalAddItemId: "add-item-modal",
      fields: [
        {
          key: "index",
          label: "Index",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "user",
          label: "User",
          sortable: false,
          isAvail: true,
          inDB: null
        },
        {
          key: "nickname",
          label: "Nickname",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "role",
          label: "Role",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          isAvail: true,
          inDB: null
        },
        {
          key: "actions",
          label: "Actions",
          isAvail: false
        },
        {
          key: "_created_at",
          label: "Created",
          isAvail: true,
          inDB: "doc_._created_at",
          formatter: "formattedDate"
        },
        {
          key: "_updated_at",
          label: "Updated",
          isAvail: false,
          inDB: "doc_._updated_at"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.status-box {
  background-color: #a9a6a6;
  border-radius: 15px;
  padding: 10px;
  margin: 15px;
}
</style>
